function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import Enrollments from './panels/Enrollments';
import ExamRegistrations from './panels/ExamRegistrations';
import Order from './panels/Order';
import Cost from './panels/Cost';
import styles from '../../../sass/status.module.scss';
export default (function (props) {
  var studentRegistrations = props.studentRegistrations,
    examRegistrations = props.examRegistrations,
    cost = props.cost,
    school = props.school,
    history = props.history,
    hideOrderPanel = props.hideOrderPanel,
    hideStudentRegistrations = props.hideStudentRegistrations;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['status-panel-container']
  }, !hideStudentRegistrations ? /*#__PURE__*/React.createElement(Enrollments, studentRegistrations) : null, /*#__PURE__*/React.createElement(ExamRegistrations, _extends({}, examRegistrations, {
    history: history
  })), /*#__PURE__*/React.createElement(Cost, cost), !hideOrderPanel ? /*#__PURE__*/React.createElement(Order, _extends({}, examRegistrations, school, {
    history: history
  })) : null);
});